import choiceMiddleware from './middleware';
import choiceReducer, { choiceSlice } from './reducer';
import * as choiceSelectors from './selectors';

const choiceActions = {
  ...choiceSlice.actions,
};

export { choiceActions, choiceMiddleware, choiceReducer, choiceSelectors };
